import {Action} from "@ngrx/store";
import {IAppParamData} from "../../models/application-parameters/application-parameters.interface";

export enum EApplicationParametersActions {
  SetLanguage = '[Application Parameters] Set Language',

  SetOrganisation = '[Application Parameters] Set Organisation',
  SetOrganisationList = '[Application Parameters] Set Organisation List',

  SetNomenclature = '[Application Parameters] Set Nomenclature',
  SetNomenclatureList = '[Application Parameters] Set Nomenclature List',

  SetSupplier = '[Application Parameters] Set Supplier',
  SetSupplierList = '[Application Parameters] Set Supplier List',

  SetDate = '[Application Parameters] Set Date',

  SetDatasourcePartyId = '[Application Parameters] Set Datasource PartyId',
  SetDatasourcePartyIdSuccess = '[Application Parameters] Set Datasource PartyId Success',

  SetFinDepartment =  '[Application Parameters] Set FinDepartment',

  SetOsaIncidentSelection = '[Application Parameters] Set Osa Incident selection type',

  SetOsaIncidentKind = '[Application Parameters] Set Osa Incident Kind',

  SetOsaIncidentType = '[Application Parameters] Set Osa Incident Type',


  ClearAppParam = '[Application Parameters] clear app param',

  SetAppParam = '[Application Parameters] set app param',

  SetAppParamSuccess = '[Application Parameters] set app param success',
  SetAppParamFailure = '[Application Parameters] set app param failure',

  RemoveAppParam = '[Application Parameters] remove app param'



}
export class SetLanguage implements Action{
  public readonly type = EApplicationParametersActions.SetLanguage;
  constructor(public payload: string){}
}

export class SetOrganisation implements Action{
  public readonly type = EApplicationParametersActions.SetOrganisation;
  constructor(public payload: {code: string, level: string}){}
}
export class SetOrganisationList implements Action{
  public readonly type = EApplicationParametersActions.SetOrganisationList;
  constructor(public payload: {list: Array<string>, level: string}){}
}

export class SetNomenclature implements Action{
  public readonly type = EApplicationParametersActions.SetNomenclature;
  constructor(public payload: {code: string, level: string}){}
}
export class SetNomenclatureList implements Action{
  public readonly type = EApplicationParametersActions.SetNomenclatureList;
  constructor(public payload: {list: Array<string>, level: string}){}
}
export class SetSupplier implements Action{
  public readonly type = EApplicationParametersActions.SetSupplier;
  constructor(public payload: string){}
}
export class SetSupplierList implements Action{
  public readonly type = EApplicationParametersActions.SetSupplierList;
  constructor(public payload: {list: Array<string>, level: string}){}
}
export class SetDate implements Action{
  public readonly type = EApplicationParametersActions.SetDate;
  constructor(public payload: {from: string, to: string, periodType: string}){}
}

export class SetDatasourcePartyId implements Action{
  public readonly type = EApplicationParametersActions.SetDatasourcePartyId;
  constructor(public payload: string){}
}
export class SetDatasourcePartyIdSuccess implements Action{
  public readonly type = EApplicationParametersActions.SetDatasourcePartyIdSuccess;
  constructor(public payload: string){}
}
export class SetFinDepartment implements Action{
  public readonly type = EApplicationParametersActions.SetFinDepartment;
  constructor(public payload: string){}
}
//-----------OSA
export class SetOsaIncidentSelection implements Action{
  public readonly type = EApplicationParametersActions.SetOsaIncidentSelection;
  constructor(public payload: string){}
}
export class SetOsaIncidentKind implements Action{
  public readonly type = EApplicationParametersActions.SetOsaIncidentKind;
  constructor(public payload: string){}
}
export class SetOsaIncidentType implements Action {
  public readonly type = EApplicationParametersActions.SetOsaIncidentType;
  constructor(public payload: Array<Array<string>>) {}
}



export class ClearAppParam implements Action {
  public readonly type = EApplicationParametersActions.ClearAppParam;
}
export class SetAppParam implements Action {
  public readonly type = EApplicationParametersActions.SetAppParam;
  constructor(public payload: IAppParamData) {}
}
export class RemoveAppParam implements Action {
  public readonly type = EApplicationParametersActions.RemoveAppParam;
  constructor(public payload: string) {}
}




export type ApplicationParametersActions =
  SetLanguage |
  SetOrganisation |
  SetOrganisationList |
  SetNomenclature |
  SetNomenclatureList |
  SetSupplier |
  SetSupplierList |
  SetDate |
  SetDatasourcePartyId |
  SetDatasourcePartyIdSuccess |
  SetFinDepartment |
  SetOsaIncidentSelection |
  SetOsaIncidentKind |
  SetOsaIncidentType |

  ClearAppParam |
  SetAppParam |
  RemoveAppParam;


